__turbopack_context__.v({
  "root": "_4S5PEa_root",
  "typeformContainer": "_4S5PEa_typeformContainer",
});
